import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreement';
import { CreditAgreementsOverview } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreementsOverview';

export const CreditAgreementsRoute = () => (
  <Switch>
    <Route
      exact
      path="/credit-agreements"
      component={CreditAgreementsOverview}
    />
    <Route
      exact
      path="/credit-agreements/:creditAgreementId"
      component={CreditAgreement}
    />
  </Switch>
);
